/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'element-accordion': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M10 12.5a1.5 1.5 0 0 1 1.5-1.5h24a1.5 1.5 0 0 1 0 3h-24a1.5 1.5 0 0 1-1.5-1.5zm0 5a1.5 1.5 0 0 1 1.5-1.5h24a1.5 1.5 0 0 1 0 3h-24a1.5 1.5 0 0 1-1.5-1.5z"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M42 8H5v14h37V8zM5 5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h37a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3H5zm37 33H5v2h37v-2zM5 35a3 3 0 0 0-3 3v2a3 3 0 0 0 3 3h37a3 3 0 0 0 3-3v-2a3 3 0 0 0-3-3H5zm37-6H5v2h37v-2zM5 26a3 3 0 0 0-3 3v2a3 3 0 0 0 3 3h37a3 3 0 0 0 3-3v-2a3 3 0 0 0-3-3H5z"/>'
  }
})
